<template>
  <div>
    <b-alert
      show
      variant="danger"
      class="custom-alert mb-0 p-2"
      dismissible
      fade
    >
      <h4 class="alert-heading font-weight-normal">Attention</h4>
      <div class="alert-body">
        <feather-icon class="mr-25" icon="StarIcon" />
        <small class="ml-25">This tabel will update every 15 minutes.</small>
        <br />
        <feather-icon class="mr-25" icon="StarIcon" />
        <small class="ml-25">The following data may have a 15% mistake.</small>
      </div>
    </b-alert>

    <data-table
      :fields="fields"
      :items="participants"
      :loading="loading"
      class=" "
    >
      <template #rank="{ data }">
        <span class="px-1 bg-dark text-white rounded py-50">
          {{ data.item.rank || "-" }}
        </span>
      </template>

      <template #user="{ data }">
        <div class="d-flex">
          <b-avatar
            rounded
            :src="data.item.user.data.avatar"
            class="mr-1 rounded-avatar"
            style="border: 2px solid #4d556d"
          />
          <div>
            {{
              data.item.user.data.first_name +
                " " +
                data.item.user.data.last_name || "-"
            }}
            <div>
              <i
                v-if="data.item.kicked_at"
                v-b-tooltip.hover.v-danger="
                  'kicked at ' + toLocal(data.item.kicked_at)
                "
                class="text-danger"
              >
                kicked
              </i>
              <i
                v-else-if="data.item.failed_at"
                v-b-tooltip.hover.v-warning="
                  'failed at ' + toLocal(data.item.failed_at)
                "
                class="text-warning"
              >
                failed
              </i>
            </div>
          </div>
        </div>
      </template>

      <template #balance="{ data }">
        {{
          hasOwnNestedProperty(data.item, "detail.balance")
            ? data.item.detail.balance.toFixed(2)
            : "-"
        }}
      </template>

      <template #profitability="{ data }">
        {{
          hasOwnNestedProperty(data.item, "detail.net_profit")
            ? data.item.detail.net_profit.toFixed(2)
            : "-"
        }}
      </template>
      <template #sell_to_buy="{ data }">
        <vue-apex-charts
          v-if="
            (data.item.detail &&
              data.item.detail.sell_to_buy &&
              data.item.detail.sell_to_buy.buy) ||
            (data.item.detail &&
              data.item.detail.sell_to_buy &&
              data.item.detail.sell_to_buy.sell)
          "
          type="donut"
          height="80"
          width="80"
          :options="donutChart.chartOptions"
          :series="[
            data.item.detail.sell_to_buy.buy,
            data.item.detail.sell_to_buy.sell,
          ]"
        />
        <span v-else>-</span>
      </template>

      <template #win_to_loss="{ data }">
        <vue-apex-charts
          v-if="
            (data.item.detail &&
              data.item.detail.win_to_loss &&
              data.item.detail.win_to_loss.win) ||
            (data.item.detail &&
              data.item.detail.win_to_loss &&
              data.item.detail.win_to_loss.loss)
          "
          type="donut"
          height="80"
          width="80"
          :options="donutChart.chartOptions2"
          :series="[
            data.item.detail.win_to_loss.win,
            data.item.detail.win_to_loss.loss,
          ]"
        />
        <span v-else>-</span>
      </template>
      <template #risk="{ data }">
        {{ data.item.risk || "-" }}
      </template>
      <template
        #actions="{ data }"
        v-if="
          userData && Object.keys(userData).length && userData.type == 'admin'
        "
      >
        <b-button
          :variant="!data.item.kicked_at ? 'flat-danger' : 'flat-warning'"
          size="sm"
          @click="toggleStatus(data.item)"
        >
          <feather-icon icon="EditIcon" />
          {{
            !data.item.kicked_at
              ? "Kick off competition"
              : "Back to competition"
          }}
        </b-button>
      </template>
    </data-table>

    <div class="w-100 d-flex flex-wrap align-items-center">
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        pills
        size="md"
        class="my-2 d-flex justify-content-center"
      >
        {{ pagination.total_pages }}
      </b-pagination>
    </div>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BAvatar,
  VBTooltip,
  BAlert,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    BAvatar,
    BAlert,
    VueApexCharts,
  },

  data() {
    return {
      selectAll: false,
      removeParticipantsData: [],
      showChangeStatus: false,
      currentData: {},
      currentPage: 1,
      loading: false,
      pagination: {},
      donutChart: {
        series: [],
        chartOptions2: {
          legend: {
            show: false,
            position: "bottom",
            color: "#fff",
            labels: {
              colors: "#fff",
              useSeriesColors: false,
            },
          },
          colors: ["#39A4F8", "#25ECFB"],
          dataLabels: {
            enabled: false,
            formatter(val) {
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                  name: {
                    fontSize: "1rem",
                    color: "#fff",
                    offsetY: 1,
                  },
                  value: {
                    fontSize: "1rem",
                    color: "#fff",
                    offsetY: 2,

                    formatter(val) {
                      return `${parseInt(val)}%`;
                    },
                  },
                  total: {
                    show: false,
                    fontSize: "1rem",
                    color: "#fff",
                    offsetY: 10,

                    label: "Participants",
                    formatter() {
                      return "380";
                    },
                  },
                },
              },
            },
          },
          labels: ["win", "loss"],
        },
        chartOptions: {
          legend: {
            show: false,
            position: "bottom",
            color: "#fff",
            labels: {
              colors: "#fff",
              useSeriesColors: false,
            },
          },
          colors: ["#FBAD25", "#FA4B68"],
          dataLabels: {
            enabled: false,
            formatter(val) {
              return `${parseInt(val)}%`;
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                  name: {
                    fontSize: ".7rem",
                    color: "#fff",
                    offsetY: 1,
                  },
                  value: {
                    fontSize: ".7rem",
                    offsetY: 2,

                    color: "#fff",
                    formatter(val) {
                      return `${parseInt(val)}%`;
                    },
                  },
                  total: {
                    show: false,
                    fontSize: ".7rem",
                    offsetY: 10,

                    color: "#fff",
                    label: "Participants",
                    formatter() {
                      return "380";
                    },
                  },
                },
              },
            },
          },
          labels: ["Buy", "Sell"],
        },
      },

      participants: [],
    };
  },
  computed: {
    url() {
      return Object.keys(this.userData).length
        ? `/panel/competitions/${this.$route.params.id}/participants`
        : `/competitions/${this.$route.params.id}/participants`;
    },
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
    fields() {
      return Object.keys(this.userData).length && this.userData.type == "admin"
        ? [
            { key: "rank", label: "rank" },
            { key: "user", label: "user" },
            { key: "balance", label: "balance" },
            { key: "profitability", label: "profitability" },
            { key: "sell_to_buy", label: "sell to buy" },
            { key: "win_to_loss", label: "win to loss" },
            { key: "risk", label: "risk" },
            { key: "actions", label: "" },
          ]
        : [
            { key: "rank", label: "rank" },
            { key: "user", label: "user" },
            { key: "balance", label: "balance" },
            { key: "profitability", label: "profitability" },
            { key: "sell_to_buy", label: "sell to buy" },
            { key: "win_to_loss", label: "win to loss" },
            { key: "risk", label: "risk" },
          ];
    },
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  created() {
    this.getParticipants();
  },

  watch: {
    currentPage(val) {
      this.removeParticipantsData = [];
      this.getParticipants(val);
    },

    selectAll: {
      handler(val) {
        val
          ? (this.removeParticipantsData = this.participants.map(
              (participant) => participant.id
            ))
          : (this.removeParticipantsData = []);
      },
      immediate: true,
    },
    removeParticipantsData: {
      handler(val) {
        val.length == this.participants.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
  },

  methods: {
    async toggleStatus(item) {
      this.loading = true;
      try {
        const { data } = await this.$http.post(
          `/panel/user/${item.user.data.id}/kick-competition?_method=patch`,
          {
            competition_id: Number(this.$route.params.id),
            is_kick: item.kicked_at ? 0 : 1,
          }
        );
        await this.getParticipants();
      } catch (err) {}
      this.loading = false;
    },
    removeParticipant(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about deleting this option ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`${this.url}/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeParticipantsData = [];
                await this.getParticipants();
              } else {
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your option has been deleted successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeParticipants() {
      if (this.removeParticipantsData.length) {
        this.$bvModal
          .msgBoxConfirm("Are you sure about deleting these options ?", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.removeParticipantsData.map(
                  async (participant) =>
                    await this.$http.delete(`${this.url}/${participant}`)
                );
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeParticipantsData = [];
                  await this.getParticipants();
                } else {
                  await this.$router.push({
                    name: "participants",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Your options have been deleted successfully.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "There is some problem",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "No option selected ",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getParticipants(page) {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        page && (params.page = page);
        const { data } = await this.$http.get(this.url, {
          params,
        });
        await data.data.forEach((item) => {
          item.status = item.kicked_at ? "K" : item.failed_at ? "F" : "";
          item._cellVariants = {
            status: item.kicked_at ? "danger" : item.failed_at ? "warning" : "",
          };
        });
        this.participants = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
